import * as tslib_1 from "tslib";
import { themr } from '@nextiva/analytics-lib';
import { Popover } from '@nextiva/next-ui';
import { ViewChartTypes } from "../../../constants";
import cx from 'classnames';
import React, { PureComponent } from 'react';
import { ColumnSvg, GaugeSvg, ScaleSvg, SmileSvg, ValueSvg } from '../../SvgIcons';
import Styles from "./ViewChartTypesPopover.css";
var items = [{
  type: ViewChartTypes.GAUGE,
  IconComponent: GaugeSvg,
  label: 'Gauge'
}, {
  type: ViewChartTypes.SCALE,
  IconComponent: ScaleSvg,
  label: 'Scale'
}, {
  type: ViewChartTypes.ICON,
  IconComponent: SmileSvg,
  label: 'Icon'
}, {
  type: ViewChartTypes.VALUE,
  IconComponent: ValueSvg,
  label: 'Value'
}];

var ViewChartTypesPopover =
/** @class */
function (_super) {
  tslib_1.__extends(ViewChartTypesPopover, _super);

  function ViewChartTypesPopover() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isOpen: false
    };

    _this.togglePopover = function () {
      _this.setState(function (state) {
        return {
          isOpen: !state.isOpen
        };
      });
    };

    _this.setViewChart = function (type) {
      return function () {
        _this.props.setViewChartType(type);

        _this.togglePopover();
      };
    };

    return _this;
  }

  ViewChartTypesPopover.prototype.renderBody = function () {
    var _this = this;

    var _a = this.props,
        theme = _a.theme,
        selectedChartType = _a.selectedChartType;
    return React.createElement("div", {
      className: theme.typeList
    }, items.map(function (_a, index) {
      var type = _a.type,
          IconComponent = _a.IconComponent,
          label = _a.label;

      var _b;

      return React.createElement("div", {
        key: index,
        onClick: _this.setViewChart(type),
        className: cx(theme.item, (_b = {}, _b[theme.itemActive] = selectedChartType === type, _b))
      }, React.createElement("div", {
        className: theme.typeIcon
      }, React.createElement(IconComponent, null)), React.createElement("div", {
        className: theme.typeLabel
      }, label));
    }));
  };

  ViewChartTypesPopover.prototype.render = function () {
    var isOpen = this.state.isOpen;
    var theme = this.props.theme;
    return React.createElement(Popover, {
      className: theme.viewChartTypesPopover,
      body: this.renderBody(),
      isOpen: isOpen,
      togglePopover: this.togglePopover
    }, React.createElement(ColumnSvg, {
      isActive: isOpen
    }));
  };

  return ViewChartTypesPopover;
}(PureComponent);

export default themr(ViewChartTypesPopover, Styles);